import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { AccessType, StoryElement } from "@quintype/components";
import { StoryHeaderCard } from "../story-page-components/story-header-card.js";
import { StoryTags } from "../story-page-components/story-tags.js";
import { StoryPageCard } from "../story-page-components/story-page-card.js";
import { DfpAd } from "../dfp-ad";
import { MetypeCommentingWidget } from "@metype/components";
import { addTargetBlankToExtLinks } from "../../../utils/add-target-blank-to-extlinks";
import { getAccessData, handleAccess, checkIfStoryPublic } from "../sso-components/sso-utils";
import { isEmpty } from "../../utils";

function getStoryCardTemplate(cards = [], story, config, firstVideo) {
  const cdnImage = get(config, ["cdn-image"], "");

  return cards.map((card, index) => {
    const { id: firstVideoId = -1 } = firstVideo;
    if (index === 0) {
      return (
        <div key={card.id} className="blank-story__card--with-ad">
          <StoryPageCard firstVideoElementID={firstVideoId} key={card.id} card={card} story={story} cdn={cdnImage} />
          <div className="app-ad app-ad--story-horizontal">
            <DfpAd adtype="Story-Middle-Ad" />
          </div>
        </div>
      );
    } else {
      return (
        <StoryPageCard firstVideoElementID={firstVideoId} key={card.id} card={card} story={story} cdn={cdnImage} />
      );
    }
  });
}

function VideoStoryTemplate(props) {
  const metypeConfig = get(props, ["config", "theme-attributes", "metype-config"], {});
  const storyAccess = get(props, ["access"]);
  const accessLoading = get(props, ["accessLoading"]);

  const isStoryPublic = checkIfStoryPublic(props.story);
  const cards = get(props, ["story", "cards"], []);

  const firstVideo =
    cards
      .reduce((acc, currEle) => {
        acc = acc.concat(currEle["story-elements"]);
        return acc;
      }, [])
      .find(
        ({ type, subtype }) => type === "youtube-video" || (type === "jsembed" && subtype === "dailymotion-video")
      ) || {};

  const HeaderVideo = props => {
    return (
      <div className="header-video" data-testid="header-video">
        <StoryElement element={firstVideo} key={firstVideo.id} story={props.story} />
      </div>
    );
  };

  return (
    <article className="blank-story video-story">
      <div className="blank-story--wrapper">
        <HeaderVideo story={props.story} />
        <div
          className={`video-story--content ${
            get(props.config, ["theme-attributes", "language_direction"]) === "right" ? "ltr-text" : ""
          }`}
        >
          <StoryHeaderCard story={props.story} config={props.config} />

          {isStoryPublic
            ? getStoryCardTemplate(cards, props.story, props.config, firstVideo)
            : handleAccess(props.story, storyAccess, accessLoading, props.config, cards =>
                getStoryCardTemplate(cards, props.story, props.config, firstVideo)
              ) /* Method to check for access of the user */}

          <StoryTags tags={props.story.tags} config={props.config} />
          <div className="blank-story__aside">
            <div className="app-ad app-ad--story-mrec">
              <DfpAd adtype="Story-Mrec" />
            </div>
          </div>
        </div>
        {!props.preview && (
          <div>
            <div className="app-ad app-ad--story-horizontal">
              <DfpAd adtype="Story-Bottom-Ad" />
            </div>
            {!isEmpty(metypeConfig) && (
              <div className="blank-story--metype-widget">
                <MetypeCommentingWidget
                  host={metypeConfig.host}
                  accountId={parseInt(metypeConfig.accountId)}
                  pageURL={generateHostUrl(props.story)}
                  primaryColor={metypeConfig.primaryColor}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </article>
  );
}

VideoStoryTemplate.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object,
  checkAccess: PropTypes.func,
  preview: PropTypes.bool
};

function generateHostUrl(story = {}) {
  if (global.location) {
    return `${global.location.origin}/${story.slug}`;
  }
}

class VideoStoryAccessWrapper extends React.Component {
  componentDidMount() {
    const { checkAccess, story, accessUpdated, accessIsLoading, config } = this.props;
    getAccessData(checkAccess, story, accessUpdated, accessIsLoading, config);
    addTargetBlankToExtLinks(this.storyWrapperElement);
  }

  render() {
    return (
      <div className="story-grid" ref={el => (this.storyWrapperElement = el)}>
        <VideoStoryTemplate {...this.props} />
      </div>
    );
  }
}

VideoStoryAccessWrapper.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object,
  checkAccess: PropTypes.func,
  accessUpdated: PropTypes.func,
  accessIsLoading: PropTypes.func
};

class VideoStoryBase extends React.Component {
  render() {
    const email = get(this.props, ["member", "email"]);
    const phone = get(this.props, ["member", "metadata", "phone-number"], "");
    const accessTypeKey = get(this.props, ["config", "theme-attributes", "accesstypeKey"]);
    const disableMetering = get(this.props, ["config", "theme-attributes", "disableMetering"]) === "true";
    const isStaging = get(this.props, ["config", "theme-attributes", "accesstypeEnvironment"]) === "staging";
    const enableAccesstype = get(this.props, ["config", "theme-attributes", "enableAccesstype"]) === "true";

    return (
      <AccessType
        enableAccesstype={enableAccesstype}
        isStaging={isStaging}
        accessTypeKey={accessTypeKey} // "9rm1ijqQmGfJ2kwQ9zt2gWhK"
        email={email}
        phone={phone}
        disableMetering={disableMetering}
      >
        {({ initAccessType, checkAccess, accessUpdated, accessIsLoading }) => (
          <VideoStoryAccessWrapper
            accessIsLoading={accessIsLoading}
            accessUpdated={accessUpdated}
            initAccessType={initAccessType}
            checkAccess={checkAccess}
            {...this.props}
          />
        )}
      </AccessType>
    );
  }
}

const mapStateToProps = state => ({
  member: get(state, ["member"], null),
  access: get(state, ["access"], null),
  accessLoading: get(state, ["accessLoading"], true)
});

export const VideoStory = connect(mapStateToProps)(VideoStoryBase);
